import React from 'react';
import { formatCurrency } from '../../../../../../../../../CommonUtils/formatNumber';
import { Box } from '../../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../../CommonComponents/OPL/Text/Text';
import { Card } from '../../../../../../../../../CommonComponents/OPL/Card/Card';

interface Props {
  shortTerm: number;
  longTerm: number;
  total: number;
}

export const MobileTotals = ({ shortTerm, longTerm, total }: Props) => {
  return (
    <Box my="24">
      <Card hasBorder boxShadow="none" borderRadius="none">
        <Box display="flex" flexDirection="column">
          <Box p="24" display="flex" flexDirection="column" flex={1}>
            <Text mb="4" variant="smallCaps" fontSize="small">
              Total Short Term Gain/Loss
            </Text>

            <Text variant="tabular" fontWeight={500} fontSize="h4">
              {formatCurrency(shortTerm, { decimalPlaces: 2 })}
            </Text>
          </Box>

          <Box
            p="24"
            display="flex"
            flexDirection="column"
            flex={1}
            borderTop="1px solid"
            borderBottom="1px solid"
            borderColor="neutral.200"
          >
            <Text mb="4" variant="smallCaps" fontSize="small">
              Total Long Term Gain/Loss
            </Text>

            <Text variant="tabular" fontWeight={500} fontSize="h4">
              {formatCurrency(longTerm, { decimalPlaces: 2 })}
            </Text>
          </Box>

          <Box p="24" display="flex" flexDirection="column" flex={1}>
            <Text mb="4" variant="smallCaps" fontSize="small">
              Total Gain/Loss
            </Text>

            <Text variant="tabular" fontWeight={500} fontSize="h4">
              {formatCurrency(total, { decimalPlaces: 2 })}
            </Text>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};
